import { render, staticRenderFns } from "./spoiler.vue?vue&type=template&id=f403ea58&scoped=true&lang=pug&"
import script from "./spoiler.vue?vue&type=script&lang=js&"
export * from "./spoiler.vue?vue&type=script&lang=js&"
import style0 from "./spoiler.scss?vue&type=style&index=0&id=f403ea58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f403ea58",
  null
  
)

export default component.exports